/**
 * Точка входа: страница расчёта заявки менеджера.
 *
 * Инициализируется только если на странице есть маркер `.adm_req_caption_wrap`
 * (основной блок заявки).
 *
 * Модули:
 *   store.js         — debounce timers + confirmCallback
 *   calculator.js    — бэкенд-расчёт товара, UI update, grand totals, collectProductData
 *   products.js      — save/approve/delete + bulk операции
 *   request.js       — archive/delete/export + add-products modal
 *   confirm-modal.js — общий модалик подтверждения
 *   ui.js            — DOM-обработчики, счётчик количества, раскрытие панелей
 */

import { initConfirmModal } from './confirm-modal.js';
import { calculateAllProducts } from './calculator.js';
import { initUi } from './ui.js';

function init() {
    if (!document.querySelector('.adm_req_caption_wrap')) return;

    initConfirmModal();
    initUi();
    calculateAllProducts();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
